import qs from 'qs';

const Competitor = {
    namespaced: true,
    state: {
        competitorData: [],
    },

    getters: {
        competitorData (state) {
            return state.competitorData;
        },
    },

    mutations: {

        /**
         * Установить значение Конкурента
         * @param state
         * @param items
         */
        setArr (state, { items }) {
            state['competitorData'] = items;
        },

        /**
         * Обновить значение элемента Конкурента
         * @param state
         * @param item
         * @param index
         */
        setItem (state, { item, index }) {
            state['competitorData'][index] = item;
        },

        /**
         * Добавить значение элемента Конкурента
         * @param state
         * @param item
         */
        addItem (state, { item }) {
            state['competitorData'].push(item);
        },

        /**
         * Удалить элемент из Конкурента
         * @param state
         * @param item
         */
        remove (state, { item }) {
            state['competitorData'] = state['competitorData'].filter(iItem => iItem !== item);
        },
    },


    actions: {

        /**
         * Получение данных по Конкурентам
         * @param commit
         * @param dispatch
         * @param getters
         * @param rootGetters
         * @returns {Promise<any>}
         */
        getCompetitorData ({ commit, dispatch, getters, rootGetters }) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});
                axios({
                    url: rootGetters.rootUrl +  'list/index',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded',
                    },
                    data: qs.stringify({
                        'token': this.getters['auth/getToken'], 
                        'service' : rootGetters.service.competitor,
                    }),
                }).then(response => (
                    commit('setArr', {
                        items: response.data
                    }),
                        dispatch('loading/isLoading', false, {root:true}),
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Данные по конкурентам получены.'),
                        resolve()
                )).catch(err => {
                        dispatch('loading/isLoading', false, {root:true}),
                        console.log('ERROR IN competitor.js | getCompetitorData : ' + err);
                        window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка в получении данных по конкурентам!'),
                        reject(err);
                });
            })
        },

        /**
         * Сохранение данных по Конкурентам
         * @param commit
         * @param data
         * @returns {Promise<any>}
         */
        saveCompetitorData ({ commit, dispatch, getters, rootGetters }, data) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});
                const str = JSON.stringify(data.data);
                axios({
                    url: rootGetters.rootUrl + 'list/save',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'data': str,
                        'token': this.getters['auth/getToken'], 
                        'service' : rootGetters.service.competitor,
                    }),
                }).then(response => {
                    console.log(response.data);
                    // Если редактирование
                    if (data.index !== -1) {
                        commit('setItem', {
                            item: data.data,
                            index: data.index
                        });
                        dispatch('loading/isLoading', false, {root:true});
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Данные по Конкурентам успешно отредактированы!');

                    // Если сохранение нового
                    } else {
                      data.data.competitorId = response.data[0].competitorId;
                        commit('addItem', {
                            item: data.data
                        });
                        dispatch('loading/isLoading', false, {root:true});
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Новый конкурент успешно создан!');
                    }
                    resolve();
                }).catch(err => {
                        dispatch('loading/isLoading', false, {root:true});
                        window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при сохранении данных!');
                        console.log('ERROR IN competitor.js | saveCompetitorData : ' + err);
                        reject(err);
                });
            })
        },

        /**
         * Удаление Конкурента
         * @param commit
         * @param data
         * @returns {Promise<any>}
         */
        removeCompetitorData ({ commit, dispatch, getters, rootGetters }, data) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});
                const str = JSON.stringify(data.item);
                axios({
                    url: rootGetters.rootUrl + 'list/delete',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'data': str,
                        'token': this.getters['auth/getToken'], 
                        'service' : rootGetters.service.competitor,
                    }),
                }).then(response => (
                    commit('remove', {
                        item: data.item
                    }),
                    dispatch('loading/isLoading', false, {root:true}),
                    window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Конкурент успешно удален!'),
                    resolve()
                )).catch(err => {
                    dispatch('loading/isLoading', false, {root:true});
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при удалении конкуернта!'),
                    console.log('ERROR IN competitor.js | removeCompetitorData : ' + err);
                    reject(err);
                });
            })
        },
    },
};

export default Competitor;





// WEBPACK FOOTER //
// ./src/store/modules/competitor.js